export default __webpack_public_path__ + "static/media/login_ellipse.1201140a.svg";